import { render, staticRenderFns } from "./upAgent.vue?vue&type=template&id=5297d84c&scoped=true&"
import script from "./upAgent.vue?vue&type=script&lang=js&"
export * from "./upAgent.vue?vue&type=script&lang=js&"
import style0 from "./upAgent.vue?vue&type=style&index=0&id=5297d84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297d84c",
  null
  
)

export default component.exports